export default "assets/images/cloud-1-25d9dc26.png";